const meta4AssemblyDelegates = { assemblyAcl: ['delegate', 'observer'] };
const meta4AssemblyManagers = { assemblyAcl: ['manager'] };
const meta4AssemblyAuthenticated = {
    assemblyAcl: ['delegate', 'observer', 'manager', 'expert'],
};
const routes = [
    {
        name: 'AssemblyHome_TM',
        path: '/:assemblyIdentifier/:assemblyType/',
        component: () => import('@/plugins/TM/Layout.vue'),
        children: [
            {
                path: '',
                name: 'TM',
                component: () => import('@/pages/Index.vue'),
            },
            {
                path: 'start',
                name: 'start__TM',
                component: () => import('@/pages/Assembly/TOC/TOC.vue'),
                meta: {
                    // hideAssemblyMenu: true,
                    ...meta4AssemblyAuthenticated,
                },
            },
            // PUBLIC ROUTE
            {
                path: 'report',
                name: 'REPORT_PARENT',
                children: [
                    {
                        path: '',
                        name: 'REPORT',
                        // component: () => import('@/plugins/TM/pages/ReportOverall.vue'),
                        component: () => import('@/plugins/TM/pages/ReportTrend.vue'),
                    },
                    {
                        path: 'trends',
                        name: 'REPORT_TRENDS',
                        component: () => import('@/plugins/TM/pages/ReportTrend.vue'),
                    },
                    {
                        path: 'teilnehmende',
                        name: 'REPORT_PARTICIPANTS',
                        component: () => import('@/plugins/TM/pages/ReportUser.vue'),
                    },
                ],
            },
            {
                path: 'report2024',
                name: 'REPORT2024',
                // component: () => import('@/plugins/TM/pages/Report2024.vue'),
                component: () => import('@/plugins/TM/pages/ReportTrend.vue'),
            },
            {
                path: 'report2025',
                name: 'REPORT2025',
                // component: () => import('@/plugins/TM/pages/Report2025.vue'),
                component: () => import('@/plugins/TM/pages/ReportTrend.vue'),
            },
            {
                path: 'LivingLineChartAll',
                name: 'LivingLineChartAll',
                component: () => import('@/plugins/TM/pages/custom/LivingLineChartAll.vue'),
            },
            {
                path: 'LivingChart2025',
                name: 'LIVINGCHART2025',
                component: () => import('@/plugins/TM/pages/custom/LivingChart2025.vue'),
            },
            // MANAGER ROUTES
            {
                path: 'assembly_manage',
                name: 'assembly_manage__TM',
                component: () => import('@/pages/Assembly/AssemblyManage.vue'),
                meta: {
                    hideAssemblyMenu: true,
                    ...meta4AssemblyManagers,
                },
            },
            {
                path: 'assembly_manage_stats_trends',
                name: 'assembly_manage_stats_trends',
                component: () => import('@/plugins/TM/pages/ReportTrend.vue'),
                meta: {
                    hideAssemblyMenu: true,
                    ...meta4AssemblyManagers,
                },
            },
            {
                path: ':stageID/trends',
                name: 'TRENDS__TM',
                component: () => import('@/plugins/TM/stages/TRENDS/Trends.vue'),
                meta: { ...meta4AssemblyDelegates },
            },
            {
                path: ':stageID/conclusion',
                name: 'CONCLUSION__TM',
                component: () => import('@/plugins/TM/pages/ReportTrend.vue'),
                meta: meta4AssemblyDelegates,
            },
        ],
    },
];
export default routes;
